export const formatDiff = ({
  value,
  formatter = (x) => x,
}: {
  value: number
  formatter: (x: number) => string | number
}) => (value < 0 ? formatter(value) : `+${formatter(value)}`)

export const toNumber = (value?: boolean | number | null) => {
  if (!value) {
    return 0
  }
  if (typeof value === 'boolean') {
    return 0
  }
  return value
}
